<template>
  <section class="insta text-center" v-if="!hidden" :style="paddingStyles">
    <header class="insta__header">
      <h6 class="insta__title" :class="[schema.settings.sectionHeaderColor]">{{ schema.settings.sectionHeader }}</h6>
      <p class="insta__blurb" :class="[schema.settings.sectionBlurbColor]">{{ schema.settings.sectionBlurb }}</p>
      <v-link class="insta__link" target="_blank" :href="schema.settings.linkUrl" secondary="secondary">{{ schema.settings.linkText }}</v-link>
    </header>
    <div class="insta__slider" ref="foursixty">

    </div>
  </section>
</template>

<script>
import Icon from '../basic/Icon.vue'
import VLink from '../buttons/VLink.vue'
import { px } from '@/scripts/filters/string.js'
import { checkUndefined } from '@/scripts/helpers/util.js'

export default {
  name: 'Instagram',
  props: {
    schema: Object
  },
  components: {
    Icon,
    VLink
  },
  data () {
    return {
      hidden: false,
      images: [],
      swiperOptions: {
        initialSlide: 4,
        slidesPerView: 'auto',
        spaceBetween: 5,
        centeredSlides: true,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            initialSlide: 4,
            spaceBetween: 10
          }
        }
      }
    }
  },
  computed: {
    paddingStyles () {
      return {
        'padding-top': px(checkUndefined(this.schema.settings.marginTop, 56)),
        'margin-bottom': px(checkUndefined(this.schema.settings.marginBottom, 56))
      }
    }
  },
  mounted () {
    const foursixtyScript = document.createElement('script')
    foursixtyScript.setAttribute('data-feed-id', 'shiko')
    foursixtyScript.setAttribute('data-open-links-in-same-page', 'false')
    foursixtyScript.setAttribute('data-theme', 'slider_v2_5')
    foursixtyScript.setAttribute('data-cell-size', '20%')
    foursixtyScript.setAttribute('data-connector-filter', '10507,10508,26219,26220')
    foursixtyScript.setAttribute('src', '//foursixty.com/media/scripts/fs.slider.v2.5.js')

    this.$refs.foursixty.appendChild(foursixtyScript)
  }
}
</script>

<style lang="scss">
  .insta {
    &__img {
      width: 154px;
      height: 154px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      z-index: 1;
    }

    &__link {
      margin-bottom: 0;
    }

    &__blurb {
      margin-bottom: 16px;
    }

    &__header {
      margin-bottom: 24px;
    }

    &__title {
      margin-bottom: 8px;
    }

    &__slider {
      position: relative;
    }

    .swiper-slide {
      width: auto;
    }

    button {
      position: absolute;
      top: 0;
      height: 154px;
      width: 50px;
      background-color: rgba(255, 255, 255, .5);
      z-index: 2;
      transition: background-color .2s ease-in;
    }

    button:hover,
    button:focus {
      background-color: rgba(255, 255, 255, .75);
    }

    &__prev {
      left: 0;
    }

    &__next {
      right: 0;
    }

    @include tablet-up {
      &__img {
        width: 304px;
        height: 304px;
      }

      button {
        position: absolute;
        top: 0;
        height: 304px;
      }
    }
  }
</style>
